<template>
    <UserEdit
        :showEditInfo="showEditInfo"
        @showModalEditDataUser="handleShowModalEditDataUser"
    />
    <header
        class="global_header weeducStudentHeader"
        :class="{ dark: dark, 'weeducStudentHeader--course': courseSidebarMenu }"
    >
        <div class="weeduc-header__inner">
            <div v-if="!courseSidebarMenu" class="weeduc-header__brand logo">
                <router-link to="/aluno">
                    <img
                        v-show="!dark"
                        src="../../../../../src/assets/logo.png"
                        alt="Início"
                    />
                    <img
                        v-show="dark"
                        src="../../../../../src/assets/logo_white.png"
                        alt="Início"
                    />
                </router-link>
            </div>
            <div
                v-else
                class="weeduc-header__brand weeduc-header__brand--course-menu"
            >
                <button
                    type="button"
                    class="icon-button weeduc-header__toolbar-menu-btn menu_mobile openSidebar"
                    aria-label="Abrir ou fechar lista de aulas"
                    @click="onMenuTriggerClick"
                >
                    <fa icon="bars" />
                </button>
            </div>

            <nav class="weeduc-header__nav menu item" aria-label="Navegação principal">
                <ul>
                    <li :class="{ active: navActiveIndex === 0 }">
                        <router-link
                            to="/aluno"
                            class="itemMenuPortalAluno"
                            active-class=""
                            exact-active-class=""
                        >
                            Início
                        </router-link>
                    </li>
                    <li
                        v-if="isCoursePlayerRoute"
                        :class="{ active: navActiveIndex === 5 }"
                    >
                        <router-link
                            :to="coursePlayerPath"
                            class="itemMenuPortalAluno"
                            active-class=""
                            exact-active-class=""
                        >
                            Curso
                        </router-link>
                    </li>
                    <li
                        v-if="dataWebsitePortal2?.showInquiry == 1"
                        :class="{ active: navActiveIndex === 1 }"
                    >
                        <router-link
                            to="/aluno/duvidas"
                            class="itemMenuPortalAluno"
                        >
                            Minhas dúvidas
                        </router-link>
                    </li>
                    <li
                        v-if="dataWebsitePortal2?.showForum == 1"
                        :class="{ active: navActiveIndex === 2 }"
                    >
                        <router-link
                            to="/aluno/forum"
                            class="itemMenuPortalAluno"
                        >
                            Fóruns
                        </router-link>
                    </li>
                    <li
                        v-if="dataWebsitePortal2?.showCertificate == 1"
                        :class="{ active: navActiveIndex === 3 }"
                    >
                        <router-link
                            to="/aluno/certificados"
                            class="itemMenuPortalAluno"
                        >
                            Certificados
                        </router-link>
                    </li>
                    <li v-if="typeId == 2" :class="{ active: navActiveIndex === 4 }">
                        <router-link
                            to="/dashboard/painel"
                            class="itemMenuPortalAluno"
                        >
                            Painel Administrativo
                        </router-link>
                    </li>
                </ul>
            </nav>

            <div class="weeduc-header__toolbar menu icone_actions">
                <ul>
                    <li
                        v-if="!courseSidebarMenu"
                        class="weeduc-header__toolbar-menu-item"
                    >
                        <button
                            type="button"
                            class="icon-button weeduc-header__toolbar-menu-btn menu_mobile openSidebar"
                            aria-label="Abrir menu"
                            @click="onMenuTriggerClick"
                        >
                            <fa icon="bars" />
                        </button>
                    </li>
                    <li
                        class="notification-item"
                        style="position: relative"
                    >
                        <button
                            type="button"
                            class="icon-button"
                            :aria-label="`Notificações${qtdnotification > 0 ? ` (${qtdnotification} não lidas)` : ''}`"
                            :aria-expanded="hasNotification"
                            @click.stop="showNotification"
                        >
                            <fa icon="fa-bell" />
                            <span
                                v-if="qtdnotification > 0"
                                class="qtd_notification"
                                aria-label="Número de notificações não lidas"
                            >{{
                                qtdnotification > 99 ? '99+' : qtdnotification
                            }}</span>
                        </button>
                        <div
                            ref="notificationContainer"
                            class="notification_bar"
                            :class="{ show: hasNotification, dark: dark }"
                        >
                            <Notification
                                :data="data"
                                title="Notificações"
                                @unread-count-updated="updateNotificationCount"
                            />
                        </div>
                    </li>

                    <li>
                        <button
                            type="button"
                            class="icon-button"
                            :aria-label="dark ? 'Alternar para modo claro' : 'Alternar para modo escuro'"
                            @click="changeViewMode()"
                        >
                            <span v-if="dark"><fa icon="sun" /></span>
                            <span v-else><fa icon="moon" /></span>
                        </button>
                    </li>

                    <li>
                        <button
                            type="button"
                            class="icon-button avatar-button"
                            aria-label="Ver perfil do usuário"
                            @click="() => $router.push('/aluno/perfil')"
                        >
                            <span class="logo_name">{{ name }}</span>
                        </button>
                    </li>

                    <li>
                        <button
                            type="button"
                            class="icon-button"
                            aria-label="Sair da conta"
                            @click="logout"
                        >
                            <fa icon="fa-power-off" />
                        </button>
                    </li>
                </ul>
            </div>
        </div>
    </header>

    <MobileMenu
        v-if="!courseSidebarMenu"
        :showMenuMobile="showMenuMobile"
        @fechar-menu-header="closeMenu"
        @logout="logout"
    />
</template>

<script>
    import UserEdit from '@/components/Student/Dashboard_Unique/Info_User/user.vue';
    import Notification from './Notifications.vue';
    import { mapState, mapActions } from 'vuex';
    import api from '@/utils/portal/notification.js';
    import MobileMenu from './mobileMenu.vue';

    export default {
        props: {
            /**
             * Na página do curso o primeiro ícone (hamburger) abre a lista de módulos/aulas
             * em vez do menu mobile do dashboard.
             */
            courseSidebarMenu: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                showEditInfo: false,
                hasNotification: false,
                qtdnotification: 0,
                data: [],
                showNavItem: false,
                name: null,
                fullName: null,
                showMenuMobile: false,
                userLoaded: false,
            };
        },

        components: {
            Notification,
            UserEdit,
            MobileMenu,
        },

        computed: {
            ...mapState(['token', 'typeId', 'user', 'dark']),
            ...mapState('portal', ['dataWebsitePortal2']),
            /**
             * Índice do item ativo derivado da rota (evita "Início" preso em 0 só por estado local).
             * -1 = nenhum item da barra principal.
             */
            navActiveIndex() {
                const path = this.$route.path;

                if (path.startsWith('/aluno/curso/')) {
                    return 5;
                }

                if (path.startsWith('/dashboard/painel')) {
                    return 4;
                }

                if (path.startsWith('/aluno/duvidas')) {
                    return 1;
                }
                if (path.startsWith('/aluno/forum')) {
                    return 2;
                }
                if (
                    path.startsWith('/aluno/certificados') ||
                    /^\/aluno\/certificado\//.test(path)
                ) {
                    return 3;
                }

                if (
                    path === '/aluno' ||
                    path === '/aluno/' ||
                    path.startsWith('/aluno/dashboard')
                ) {
                    return 0;
                }

                return -1;
            },
            isCoursePlayerRoute() {
                return this.$route.path.startsWith('/aluno/curso/');
            },
            coursePlayerPath() {
                const slug = this.$route.params.slug;
                return slug ? `/aluno/curso/${slug}` : '/aluno/dashboard';
            },
        },

        watch: {
            user: {
                handler(newVal) {
                    if (newVal && newVal.name) {
                        this.loadDataUser();
                        this.userLoaded = true;
                    }
                },
                immediate: true,
                deep: true,
            },
            token: {
                handler(newVal) {
                    if (newVal) {
                        this.getNumberNitification();
                        this.getDataNotification();
                    }
                },
                immediate: true,
            },
            showMenuMobile(val) {
                if (!this.courseSidebarMenu) {
                    document.body.style.overflow = val ? 'hidden' : '';
                }
            },
        },

        methods: {
            ...mapActions(['toggleDarkMode', 'restoreDarkMode', 'storeShowSidebar']),

            onMenuTriggerClick() {
                if (this.courseSidebarMenu) {
                    this.storeShowSidebar({
                        showSidebar: !this.$store.state.showSidebar,
                    });
                    return;
                }
                this.showMenuMobile = !this.showMenuMobile;
            },

            async loadDataUser() {
                if (this.user && this.user.name) {
                    this.fullName = this.user.name;
                    this.name = this.user.name.substring(0, 2);
                } else {
                    this.fullName = '';
                    this.name = '';
                }
            },

            async getDataNotification() {
                try {
                    const response = await api.getDataNotifications(this.token);
                    this.data = response;
                } catch (error) {
                    console.error('Erro na listagem das notificações:', error);
                }
            },

            async getNumberNitification() {
                try {
                    const response = await api.getNumberNotifications(
                        this.token
                    );
                    this.qtdnotification = response;
                } catch (error) {
                    console.error('Erro ao buscar número de notificações:', error);
                }
            },

            updateNotificationCount(count) {
                this.qtdnotification = count;
            },

            logout() {
                localStorage.removeItem('vuex');
                localStorage.removeItem('activeIndex');
                localStorage.removeItem('logado');
                window.location.href = '/portal';
                this.restoreDarkMode();
            },

            handleShowModalEditDataUser(showEditInfo) {
                this.showEditInfo = showEditInfo;
            },

            changeViewMode() {
                const darkLocal = !this.dark;
                this.toggleDarkMode({ dark: darkLocal });
            },

            showNotification() {
                this.hasNotification = !this.hasNotification;
            },

            closeMenu() {
                this.showMenuMobile = false;
            },

            handleClickOutside(event) {
                const clickedOutsideNotification =
                    this.$refs.notificationContainer &&
                    !this.$refs.notificationContainer.contains(event.target);

                if (clickedOutsideNotification) {
                    this.hasNotification = false;
                }
            },
        },

        mounted() {
            document.addEventListener('click', this.handleClickOutside);

            if (this.token) {
                this.getNumberNitification();
                this.getDataNotification();
            } else {
                this.$nextTick(() => {
                    if (this.token) {
                        this.getNumberNitification();
                        this.getDataNotification();
                    }
                });
            }

            if (this.user && this.user.name) {
                this.loadDataUser();
                this.userLoaded = true;
            }

            if (this.dark) {
                document.body.classList.add('dark');
            } else {
                document.body.classList.remove('dark');
            }
        },

        beforeUnmount() {
            document.removeEventListener('click', this.handleClickOutside);
        },
    };
</script>

<style scoped>
    @import url(./index.css);
</style>
